import { render, staticRenderFns } from "./CategoryAddNew.vue?vue&type=template&id=284be172"
import script from "./CategoryAddNew.vue?vue&type=script&lang=js"
export * from "./CategoryAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports